import React from 'react'
import Select from 'react-select-virtualized'
import CreatableSelect from 'react-select/creatable'

export default function MileSearchBar(props) {
  const { searchValue, setSearchValue, options, placeholder } = props
  
  return (
    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
      <div style={{ width: '80%', display: 'inline-block' }}>
        <CreatableSelect
          isClearable
          value={searchValue}
          onChange={(e) => {
            setSearchValue(e)
          }}
          options={options}
          menuPlacement="auto"
          placeholder={placeholder}
        />
      </div>
      <span style={{ marginRight: '10px', alignSelf: 'center', display: 'inline-block' }}>Miles</span>
    </div>
  )
  //
  // return (
  //   <div style={{ display: 'flex', justifyContent: 'space-between' }}>
  //     <div style={{ width: '80%', display: 'inline-block' }}>
  //       <Select
  //         value={searchValue}
  //         onChange={(e) => {
  //           setSearchValue(e)
  //         }}
  //         options={options}
  //         menuPlacement="auto"
  //         placeholder={placeholder}
  //       />
  //     </div>
  //     <span style={{ marginRight: '10px', alignSelf: 'center', display: 'inline-block' }}>Miles</span>
  //   </div>
  // )
}
